import { withTheme } from 'styled-components'
import CvItem from './CvItem'

export default withTheme(CvItem)
